import { RefObject } from 'react';

import { ActionCreatorWithPayload } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../../../../store/hooks';
import { FiltersPayloadModel } from '../../../../models/filters-payload.model';

export const useClearText = <TProperty>(
  inputRef: RefObject<HTMLInputElement>,
  dispatchAction: ActionCreatorWithPayload<FiltersPayloadModel<TProperty>>,
  property: keyof TProperty
): (() => void) => {
  const dispatch = useAppDispatch();

  return (): void => {
    if (inputRef.current) {
      inputRef.current.value = '';
    }

    const nameFilter: FiltersPayloadModel<TProperty> = {
      property,
      filterValue: '',
    };

    dispatch(dispatchAction(nameFilter));
  };
};
